import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Axios from "@/shared/api/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import PaginationDot from "@/components/ui/PaginationDot";

import IdolCoverCard from '@/components/ui/IdolCoverCard';
import StatusModal from '@/components/ui/StatusModal';

const IdolsRecommend = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const idolId = useSelector((state) => state.user.idolId);

  const [pageParams, setPageParams] = useState({
    page: 1,
    limit: 3,
    idol_id: idolId,
  });

  const [list, setList] = useState(null);
  const [total, setTotal] = useState(null);

  // API 非成功狀態碼統一由 StatusModal 顯示（含攔截器附加的 HTTP_xxx）
  const statusModalRef = useRef(null);
  const [currentStatusCode, setCurrentStatusCode] = useState('');

  const getList = async (params) => {
    try {
      const res = await Axios.post("/idol/recommend-idol", params);
      switch (res.data.status_code) {
        case "SYSTEM_1000":
          setList(res.data.data);
          setTotal(res.data.total);
          break;
        default:
          setCurrentStatusCode(res.data.status_code);
          statusModalRef.current?.show();
          break;
      }
    } catch (error) {
      // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
      if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
        setCurrentStatusCode(error.httpErrorCode);
        statusModalRef.current?.show();
      } else if (!error.httpErrorCode) {
        console.error('Get recommend idol list error:', error);
      }
    }
  };

  const handlePageChange = (number) => {
    const newPageParams = { ...pageParams, page: number };
    setPageParams(newPageParams);
    getList(newPageParams);
  };

  useEffect(() => {
    getList(pageParams);
  }, []);

  return (
    <div className="pb-4">
      <h5
        className="mb-3 hover-p d-flex align-items-center"
        onClick={() => navigate('/idols')}
      >
        <FontAwesomeIcon icon={["fas", "fire"]} className="me-2 text-primary" />
        <span>{t("idols_suggestions")}</span>
        <FontAwesomeIcon
          icon={["fas", "angle-right"]}
          className="ms-2"
          size="sm"
        />
      </h5>
      {list && list.length > 0 ? (
        list.map((item) => (
          <IdolCoverCard
            key={item.idol_id}
            href={`/idol/${item.idol_uuid}`}
            coverUrl={item.idol_cover_url}
            avatarUrl={item.idol_avatar_url}
            nickName={item.idol_nick_name}
            isOfficial={item.idol_is_official}
            idolId={item.idol_id}
            className="mb-3"
          />
        ))
      ) : (
        <div className="mb-3">
          {t('no_data')}
        </div>
      )}
      {list && list.length > 0 ? (
        <PaginationDot
          total={total}
          limit={pageParams.limit}
          currentPage={pageParams.page}
          onPageChange={handlePageChange}
        />
      ) : (
        ""
      )}
      <StatusModal ref={statusModalRef} statusCode={currentStatusCode} />
    </div>
  );
};

export default IdolsRecommend;
